import { BaseService } from 'core/services';
import ProductHistoryRouteService from './ProductHistoryRouteService';

class ProductHistoryService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ProductHistoryRouteService());
    }
}

export default ProductHistoryService;
